module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('panel', {
    attrs: {
      "title": "Informações do Produto"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": _vm.$t('title.label'),
      "columns": 6,
      "error": _vm.getErrorByProductId('title', _vm.product.productId)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.title),
      expression: "product.title"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "slot": "product",
      "label": "Descrição",
      "columns": 12,
      "error": _vm.getErrorByProductId('description', _vm.product.productId),
      "required": true
    },
    slot: "product"
  }, [_c('quill-editor', {
    attrs: {
      "options": {
        placeholder: 'Adicione a descrição do seu produto aqui'
      }
    },
    model: {
      value: (_vm.product.description),
      callback: function($$v) {
        _vm.$set(_vm.product, "description", $$v)
      },
      expression: "product.description"
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-680af390","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductProvide/Edit/Moovin/Product.vue
// module id = 3248
// module chunks = 0